import {
    SaleOrderChildLinkedWrapper,
    SaleOrderLinkedTitle,
} from "../Styled";
import { QuantityBubble } from "../Styled";
import { StyledNavLink } from "../../../../shared/styled/TableStyles";

interface Props {
    saleOrders: {id: string, name: string}[];
    requestedProducts?: { id: string; name: string; quantity: number }[];
}
export const SaleOrderLink = ({ saleOrders, requestedProducts = [] }: Props) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <SaleOrderChildLinkedWrapper>
                <SaleOrderLinkedTitle>
                    Mã đơn hàng:
                </SaleOrderLinkedTitle>
                <span>
                    {saleOrders.map((item, idx) => (
                        <>
                            <StyledNavLink to={`/product-orders/${item.id}`} key={item.id}>
                                {item.name}
                            </StyledNavLink>
                            {idx < saleOrders.length - 1 ? <span>, </span> : null}
                        </>
                    ))}
                </span>
            </SaleOrderChildLinkedWrapper>
            {requestedProducts.length > 0 && (
                <SaleOrderChildLinkedWrapper>
                    <SaleOrderLinkedTitle>
                        Sản phẩm yêu cầu:
                    </SaleOrderLinkedTitle>
                    <span>
                        {requestedProducts.map((p, i) => (
                            <>
                                <StyledNavLink key={p.id} to={`/products/${p.id}`}>
                                    {p.name}
                                </StyledNavLink>
                                <QuantityBubble>x{p.quantity}</QuantityBubble>
                                {i < requestedProducts.length - 1 ? <span>, </span> : null}
                            </>
                        ))}
                    </span>
                </SaleOrderChildLinkedWrapper>
            )}
        </div>
    );
};
